{
  "loading": "Laden...",
  "placeholder": "Option auswählen..."
}